import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SERVICE_CATEGORIES } from "../data/content";
import { PAGE_SEO } from "../data/seoContent";
import SEO, { breadcrumbSchema } from "../components/SEO";
import Breadcrumb from "../components/Breadcrumb";

export default function Services() {
  const crumbs = [{ name: "Home", path: "/" }, { name: "Services", path: "/services" }];
  return (
    <div data-testid="page-services">
      <SEO {...PAGE_SEO.services} schema={breadcrumbSchema(crumbs)} />
      <section className="bg-[#0A0F1C] text-white pt-16 pb-24 lg:pt-24 lg:pb-32">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className="mb-8"><Breadcrumb items={crumbs} theme="dark" /></div>
          <p className="text-[10px] uppercase tracking-[0.3em] text-white/50 mb-6">Services</p>
          <h1 className="font-display text-5xl lg:text-7xl font-bold tracking-tight max-w-4xl leading-[1.05]">
            End-to-end property<br/><span className="gs-gradient-text">compliance programmes.</span>
          </h1>
          <p className="mt-8 text-lg text-white/70 max-w-2xl leading-relaxed">
            From single-building surveys to national portfolio programmes — each service is scoped to UK legislation, delivered with audit-ready reporting and backed by ISO-aligned management systems.
          </p>
        </div>
      </section>

      <section className="bg-white">
        <div className="max-w-[1400px] mx-auto">
          {SERVICE_CATEGORIES.map((s, idx) => (
            <Link key={s.slug} to={`/services/${s.slug}`} className="group block border-b border-slate-200 hover:bg-[#0A0F1C] hover:text-white transition-colors" data-testid={`services-row-${s.slug}`}>
              <div className="px-6 lg:px-10 py-10 lg:py-14 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
                <div className="lg:col-span-1">
                  <span className="font-display text-4xl text-slate-300 group-hover:text-white/30">0{idx + 1}</span>
                </div>
                <div className="lg:col-span-4">
                  <p className="text-[10px] uppercase tracking-[0.25em] text-slate-500 group-hover:text-white/50 mb-3">{s.brand}</p>
                  <h3 className="font-display text-3xl lg:text-4xl font-semibold">{s.name}</h3>
                </div>
                <div className="lg:col-span-5">
                  <p className="text-slate-600 group-hover:text-white/70 text-lg leading-relaxed">{s.summary}</p>
                  <p className="text-[10px] uppercase tracking-[0.25em] text-slate-500 group-hover:text-white/40 mt-3">{s.legislation}</p>
                </div>
                <div className="lg:col-span-2 flex lg:justify-end">
                  <ArrowUpRight className="w-8 h-8 text-slate-300 group-hover:text-white transition-colors" strokeWidth={1.2} />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
